import React, { createContext, useRef, useCallback } from 'react'
import { useReducer } from 'react'
import { loadGraphicsPage } from './team_graphics/graphics'

const store = createContext({})

const { Provider } = store

const actions = {
  SET_LOADING: 'SET_LOADING',
  LOAD_GRAPHICS: 'LOAD_GRAPHICS',
  SET_GRAPHICS: 'SET_GRAPHICS',
  SET_FILTER: 'SET_FILTER',
  SELECT_GRAPHIC: 'SELECT_GRAPHIC',
  PAGINATE: 'PAGINATE',
}

const useEnhancedReducer = (reducer, initState, initializer) => {
  const lastState = useRef(initState)
  const getState = useCallback(() => lastState.current, [])
  return [
    ...useReducer(
      (state, action) => lastState.current = reducer(state, action),
      initState,
      initializer,
    ),
    getState,
  ]
}

const reduce = (state, action) => {
  switch (action.type) {
    case actions.SET_LOADING:
      return { ...state, loading: action.payload }
    case actions.SET_GRAPHICS:
      return { ...state,
        graphics: action.graphics,
        page: action.page,
        perPage: action.perPage,
        totalPages: action.totalPages,
        totalEntries: action.totalEntries,
        loading: false
      }
    case actions.SET_FILTER:
      return { ...state, filter: action.payload }
    case actions.PAGINATE:
      return {
        ...state,
        page: action.page,
      }
    case actions.SELECT_GRAPHIC:
      state.menuDispatch({ type: state.menuActions.SELECT_ITEM, payload: action.payload })
      if (state.selectedGraphics.map(g => g.id).includes(action.payload.id)) {
        return { ...state, selectedGraphics: state.selectedGraphics.filter(g => g.id !== action.payload.id) }
      } else {
        return { ...state, selectedGraphics: [...state.selectedGraphics, action.payload] }
      }
    default:
      return state
  }
}

const StateProvider = (props) => {
  const initialState = {
    ...props,
    graphics: null,
    page: 1,
    per_page: null,
    total_pages: null,
    total_entries: null,
    loading: true,
    filter: '',
    selectedGraphics: props.selectedItems.filter(item => item.type == 'graphic')
  }

  const [state, dispatch, getState] = useEnhancedReducer(reduce, initialState)

  const asyncDispatch = (action) => {
    const state = getState()
    switch (action.type) {
      case actions.LOAD_GRAPHICS:
        dispatch({ type: actions.SET_LOADING, payload: true })
        return loadGraphicsPage(state, dispatch, actions.SET_GRAPHICS)
      default:
        return dispatch(action)
    }
  }

  const usableData = {
    ...state,
    actions,
  }

  const value = {
    ...usableData,
    dispatch: asyncDispatch.bind(usableData)
  }

  return <Provider value={value}>{props.children}</Provider>
}

export { store, StateProvider, actions }
